<template>
  <div class="teaser-map-button" :class="{ 'is-rect': isRect }">
    <button
      class="button"
      :class="{ 'is-loading': isLoading }"
      @click="$emit('open')"
    >
      <img
        src="~/assets/images/map-teaser-background.png"
        width="1188"
        height="160"
        alt="Map"
        loading="lazy"
      />
      <div class="button">{{ title }}</div>
    </button>
  </div>
</template>

<script lang="ts" setup>
/* Nuxt 2 version:
import Vue from 'vue'
import { PropOptions } from 'vue/types'
export default Vue.extend({
 name: 'TeaserMapButton',
 props: {
   title: {
     type: String,
     default: '',
   } as PropOptions<string>,
   isLoading: {
     type: Boolean,
     default: false,
   } as PropOptions<boolean>,
   isRect: {
     type: Boolean,
     default: false,
   } as PropOptions<boolean>,
 },
})
*/

withDefaults(
  defineProps<{
    title?: string
    isLoading?: boolean
    isRect?: boolean
  }>(),
  {
    title: '',
    isLoading: false,
    isRect: false,
  },
)

defineEmits<{
  open: []
}>()
</script>

<style>
@reference '~/assets/css/tailwind.css';
.teaser-map-button {
  &.is-rect {
    > .button {
      img {
        @apply desktop:h-full desktop:object-cover;
      }
    }
    @variant desktop {
      height: 9rem;
      > .button {
        height: 100%;
      }
    }
  }
  > .button {
    @apply relative h-auto w-full border-0 p-0;
    .button {
      @apply w-full;
    }
    @apply desktop:border desktop:border-border;
    .button {
      @apply desktop:absolute desktop:top-1/2 desktop:left-1/2 desktop:w-auto;
      @variant desktop {
        transform: translate(-50%, -50%);
      }
    }
    img {
      @apply hidden;
      @apply desktop:block;
    }
  }
}
</style>
